import { ONBOARDING_MS_URL } from '@portal/config/env';
import { getCleanInstance } from '@portal/repositories/securitySdkConfig';
import storeCreator from '@portal/reducers/createStore';

import { Consultation } from '@portal/models/bcProtege';

const client = getCleanInstance(ONBOARDING_MS_URL);

client.interceptors.request.use((config) => {
  const state = storeCreator.getState() as {
    auth?: { authToken?: { accessToken?: string | null } };
  };
  const token = state.auth?.authToken?.accessToken;
  if (token) {
    config.headers = config.headers ?? {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const OnboardingMsApi = {
  sendConsulting: async (taxIdentifier: string): Promise<Consultation> => {
    const { data } = await client.post<Consultation>('/consulting', {
      taxIdentifier,
    });
    return data;
  },

  getConsulting: async (id: string): Promise<Consultation> => {
    const { data } = await client.get<Consultation>(`/consulting/${id}`);
    return data;
  },
};

export default OnboardingMsApi;
